import { UIEvent, useCallback, useContext, useState } from "react";
import { useTranslation } from "react-i18next";

import { TranslationContext } from "@is/constants";
import { ViewStateContext } from "@is/contexts";
import { TrackingEventTypes, trackEvent } from "@is/services/EventTracking";

const useManagePasscodeView = () => {
  const { t } = useTranslation(TranslationContext.Settings);

  const [isScrolled, setIsScrolled] = useState(false);

  const {
    settings: { updateViewState: updateSettingsViewState },
    content: { updateViewState: updateContentViewState },
  } = useContext(ViewStateContext);

  const handleClose = useCallback(() => {
    updateContentViewState({ showSettingsDrawer: false });
  }, [updateContentViewState]);

  const handleScroll = useCallback((event: UIEvent<HTMLDivElement>) => {
    const { scrollTop } = event.currentTarget;
    setIsScrolled(scrollTop > 0);
  }, []);

  const handlePasscodeViewClose = useCallback(() => {
    updateSettingsViewState({ showPasscodeView: false });
  }, [updateSettingsViewState]);

  return {
    isScrolled,
    handleScroll,
    handleClose,
    handlePasscodeViewClose,
    t,
  };
};

export default useManagePasscodeView;
